import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchSolutionProposalsRequest,
  fetchSolutionProposalsSuccess,
  fetchSolutionProposalsFailure,
  createSolutionProposalRequest,
  createSolutionProposalSuccess,
  createSolutionProposalFailure,
  updateSolutionProposalRequest,
  updateSolutionProposalSuccess,
  updateSolutionProposalFailure,
  deleteSolutionProposalRequest,
  deleteSolutionProposalSuccess,
  deleteSolutionProposalFailure,
} from "./solutionProposalsSlice";
import { fastApiURL } from "../../utils/config";
import TokenManager from "../../utils/tokenManager"; 


function* fetchProposals(action) {
  try {
    const { projectId } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/solution-proposals`, {
      headers: { 
        "Content-Type": "application/json", 
        "Authorization": `Bearer ${token}` 
      },
    });
    if (!response.ok) throw new Error("Failed to fetch proposals");
    const data = yield response.json();
    yield put(fetchSolutionProposalsSuccess(data));
  } catch (error) {
    yield put(fetchSolutionProposalsFailure(error.message));
  }
}

function* createProposal(action) {
  try {
    const { projectId, payload, onSuccess } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/solution-proposals`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json", 
        "Authorization": `Bearer ${token}` 
      },
      body: JSON.stringify(payload),
    });
    const data = yield response.json();
    if (!response.ok) throw new Error(data.detail || "Failed to create proposal");
    yield put(createSolutionProposalSuccess(data));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(createSolutionProposalFailure(error.message));
    alert(error.message); 
  }
}

function* updateProposal(action) {
  try {
    const { projectId, proposalId, payload, onSuccess } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/solution-proposals/${proposalId}`, {
      method: "PUT",
      headers: { 
        "Content-Type": "application/json", 
        "Authorization": `Bearer ${token}` 
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error("Failed to update proposal");
    const data = yield response.json();
    yield put(updateSolutionProposalSuccess(data));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(updateSolutionProposalFailure(error.message));
  }
}

function* deleteProposal(action) {
  try {
    const { projectId, proposalId } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/solution-proposals/${proposalId}`, {
      method: "DELETE",
      headers: { 
        "Content-Type": "application/json", 
        "Authorization": `Bearer ${token}` 
      },
    });
    if (!response.ok) throw new Error("Failed to delete proposal");
    yield put(deleteSolutionProposalSuccess(proposalId));
  } catch (error) {
    yield put(deleteSolutionProposalFailure(error.message));
  }
}

export function* watchSolutionProposals() {
  yield takeLatest(fetchSolutionProposalsRequest.type, fetchProposals);
  yield takeLatest(createSolutionProposalRequest.type, createProposal);
  yield takeLatest(updateSolutionProposalRequest.type, updateProposal);
  yield takeLatest(deleteSolutionProposalRequest.type, deleteProposal);
}